export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export default WEEKDAYS;
